import { Component } from '@angular/core';

@Component({
  selector: 'app-tag-manager-container',
  templateUrl: './provider-container.component.html',
  standalone: false,
})
export class ProviderContainerComponent {}
